import React from 'react';

import {MobileMenu} from '../HeaderMobileMenu/HeaderMobileMenu';
import {HeaderLogo} from '../HeaderLogoBlock/HeaderLogoBlock';
import {HeaderMenu} from '../HeaderMenu/HeaderMenu';
import {HeaderActions} from '../HeaderActions/HeaderActions';
import {HeaderSearch} from '../HeaderSearch/HeaderSearch';

export default function HeaderLayoutCenter({ links, item_count = '', settings }) {
    // Check if the dedicated search block exists
    const hasSearchBlock = settings.blocks.some(block => block.type === "search_bar");
    
    return (
        <div className="w-full flex items-center relative lg:py-[10px]">
            <div className={'mobile-menu-container lg:hidden lg:basis-1/3'}>
                <MobileMenu link_list={links} settings={settings}/>
            </div>

            <div className={'hidden lg:block flex-grow lg:basis-1/3'}>
                <HeaderMenu link_list={links} settings={settings}/>
            </div>

            <div className={'flex relative justify-center flex-grow-0 basis-1/3'}>
                <HeaderLogo settings={settings} className={''}/>
            </div>

            <div className="flex items-center space-x-[24px] justify-end header-toolbar flex-grow lg:basis-1/3">
                {hasSearchBlock && (
                    <HeaderSearch settings={settings} />
                )}
                <HeaderActions item_count={item_count} settings={settings}/>
            </div>
        </div>
    );
}